const LogoutIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="arrow-up-left-from-circle 1" clipPath="url(#clip0_112_378)">
        <path
          id="Vector"
          d="M12.5 13.125C12.6599 13.125 12.8198 13.064 12.9418 12.9419C13.1859 12.6977 13.1859 12.302 12.9418 12.0583L2.13398 1.25H6.875C7.21875 1.25 7.5 0.970312 7.5 0.625C7.5 0.279687 7.21875 0 6.875 0H0.625C0.279531 0 0 0.279531 0 0.625V6.875C0 7.21875 0.279531 7.5 0.625 7.5C0.970469 7.5 1.25 7.21875 1.25 6.875V2.13398L12.0586 12.9426C12.1797 13.0625 12.3398 13.125 12.5 13.125ZM11.25 2.5C10.332 2.5 9.42617 2.6416 8.5582 2.92227C8.23047 3.02734 8.05078 3.38008 8.15625 3.70859C8.26172 4.03711 8.61328 4.21875 8.94141 4.11328C9.65234 3.87227 10.4609 3.75 11.25 3.75C15.3867 3.75 18.75 7.11445 18.75 11.25C18.75 15.3855 15.3855 18.75 11.25 18.75C7.11445 18.75 3.75 15.3855 3.75 11.25C3.75 10.4625 3.87207 9.68633 4.11133 8.9418C4.18359 8.61328 4.03516 8.26172 3.70859 8.15625C3.38398 8.05078 3.02852 8.23047 2.92227 8.55859C2.6418 9.42578 2.5 10.332 2.5 11.25C2.5 16.0742 6.42578 20 11.25 20C16.0742 20 20 16.0742 20 11.25C20 6.42578 16.0742 2.5 11.25 2.5Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_112_378">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LogoutIcon;
